import { useState } from "react";

// Contact Section - Mobile Optimized
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = encodeURIComponent(
      `Contacto desde web:\n` +
      `Nombre: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Teléfono: ${formData.phone}\n` +
      `Asunto: ${formData.subject}\n` +
      `Mensaje: ${formData.message}`
    );
    window.open(`https://wa.me/34600221794?text=${message}`, "_blank");
  };

  const contactInfo = [
    { icon: "fa-phone", label: "Teléfono", value: "+34 600 221 794", link: "tel:+34600221794" },
    { icon: "fa-envelope", label: "Email", value: "transferdelsur976@gmail.com", link: "mailto:transferdelsur976@gmail.com" },
    { icon: "fa-map-marker-alt", label: "Dirección", value: "Aeropuerto de Málaga, 29004" },
    { icon: "fa-instagram", label: "Instagram", value: "@transferdelsur", link: "https://instagram.com/transferdelsur" }
  ];

  return (
    <section id="contacto" className="py-16 sm:py-24 px-4 bg-[#0a0a14]" data-testid="contact-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <p className="section-subtitle">Contacto</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: "'Cinzel', serif" }}>
            ¿Tiene Alguna <span className="gradient-text">Pregunta</span>?
          </h2>
          <p className="text-sm sm:text-base text-gray-400 mt-3 sm:mt-4 max-w-2xl mx-auto px-2">
            Disponibles 24/7 para atender sus consultas y reservas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Info */}
          <div className="space-y-3 sm:space-y-6">
            {contactInfo.map((info, idx) => (
              <div
                key={idx}
                className="glass rounded-lg sm:rounded-xl p-4 sm:p-6 flex items-center gap-3 sm:gap-4"
                data-testid={`contact-info-${idx}`}
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#c9a962]/10 flex items-center justify-center flex-shrink-0">
                  <i className={`fas ${info.icon} text-[#c9a962] text-sm sm:text-base`}></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs sm:text-sm text-gray-500">{info.label}</p>
                  {info.link ? (
                    <a href={info.link} className="text-sm sm:text-base text-white hover:text-[#c9a962] transition-colors truncate block">
                      {info.value}
                    </a>
                  ) : (
                    <p className="text-sm sm:text-base text-white truncate">{info.value}</p>
                  )}
                </div>
              </div>
            ))}

            <a
              href="https://wa.me/34600221794?text=Hola,%20me%20gustar%C3%ADa%20solicitar%20informaci%C3%B3n%20sobre%20sus%20servicios%20VTC"
              className="btn-primary w-full flex items-center justify-center gap-2 mt-4 sm:mt-6 py-3.5 sm:py-4"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-contact-btn"
            >
              <i className="fab fa-whatsapp text-lg"></i>
              Contactar por WhatsApp
            </a>
          </div>

          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="glass rounded-xl sm:rounded-2xl p-5 sm:p-8" data-testid="contact-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-xs sm:text-sm text-gray-400 mb-1.5 sm:mb-2">Nombre *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="luxury-input w-full text-sm sm:text-base"
                  required
                  data-testid="contact-input-name"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm text-gray-400 mb-1.5 sm:mb-2">Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="luxury-input w-full text-sm sm:text-base"
                  required
                  data-testid="contact-input-email"
                />
              </div>
            </div>

            <div className="mt-4 sm:mt-6">
              <label className="block text-xs sm:text-sm text-gray-400 mb-1.5 sm:mb-2">Teléfono</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="luxury-input w-full text-sm sm:text-base"
                data-testid="contact-input-phone"
              />
            </div>

            <div className="mt-4 sm:mt-6">
              <label className="block text-xs sm:text-sm text-gray-400 mb-1.5 sm:mb-2">Asunto *</label>
              <input
                type="text"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                className="luxury-input w-full text-sm sm:text-base"
                required
                data-testid="contact-input-subject"
              />
            </div>

            <div className="mt-4 sm:mt-6">
              <label className="block text-xs sm:text-sm text-gray-400 mb-1.5 sm:mb-2">Mensaje *</label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="luxury-input w-full h-24 sm:h-32 resize-none text-sm sm:text-base"
                required
                data-testid="contact-input-message"
              ></textarea>
            </div>

            <button
              type="submit"
              className="btn-primary w-full mt-4 sm:mt-6 py-3 sm:py-4"
              data-testid="contact-submit-btn"
            >
              Enviar Mensaje
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
